// removed by extract-text-webpack-plugin
module.exports = {"galleryWrapper":"galleryWrapper__27DbX","swiper-container":"swiper-container__3xZ3k","slideContainer":"slideContainer__z1RhX","iconZoom":"iconZoom__3Ng4C"};


//////////////////
// WEBPACK FOOTER
// ./components/spareparts/galleryImage/style.less
// module id = 8Jr4
// module chunks = 75